export default __webpack_public_path__ + "static/media/e68c0ce3cd1a74764aafd456b277bee9.eb0bd353.jpg";